import { useEffect, useLayoutEffect, useRef } from 'react';

export type CelebrationEvent = 'bind';

const CELEBRATE_EVENT = 'lio:celebrate';

// opens HolidayPreviewMenu; fired by `lio.previewHoliday()` in the console
export const OPEN_HOLIDAY_PREVIEW_EVENT = 'lio:open-holiday-preview';

// effects that burst from a point use this: the middle of the bind-in-progress message
export const getCelebrationOrigin = () => ({ x: window.innerWidth / 2, y: window.innerHeight * 0.4 });

/**
 * Announce a happy moment (e.g. a policy bound). Safe to call any time: it only does something
 * when the active holiday has mounted a listener for it.
 */
export const celebrate = (event: CelebrationEvent) => {
  window.dispatchEvent(new CustomEvent<CelebrationEvent>(CELEBRATE_EVENT, { detail: event }));
};

export const useCelebration = (event: CelebrationEvent, handler: () => void) => {
  const handlerRef = useRef(handler);
  useLayoutEffect(() => {
    handlerRef.current = handler;
  });

  useEffect(() => {
    const listener = (e: Event) => {
      if ((e as CustomEvent<CelebrationEvent>).detail === event) handlerRef.current();
    };
    window.addEventListener(CELEBRATE_EVENT, listener);
    return () => window.removeEventListener(CELEBRATE_EVENT, listener);
  }, [event]);
};
